import Api from '@/services/api';
import {removeEmptyParams} from '@utils';

export default {
  list(filter) {
    return Api()
      .get('/mailtemplates', {params: removeEmptyParams(filter)})
      .then((res) => {
        res.data.forEach((e) => {
          this.formatRes(e);
        });
        return res.data;
      });
  },
  mailTemplate(id) {
    return Api()
      .get('/mailtemplate/' + id)
      .then((res) => this.formatRes(res.data));
  },
  create(mailTemplate) {
    return Api()
      .post('/mailtemplate', mailTemplate)
      .then((res) => this.formatRes(res.data));
  },
  update(mailTemplate) {
    return Api()
      .put('/mailtemplate/' + mailTemplate.id, mailTemplate)
      .then((res) => this.formatRes(res.data));
  },
  formatRes(e) {
    return e;
  },
};
